//this is the best place to initialize all backward compatibility stuff
//this is entrypoit for all vue projects
import '#public/commons-global';

import type { VueQueryPluginOptions } from '@tanstack/vue-query';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import {
    type Component,
    configureCompat,
    createApp,
} from 'vue';

configureCompat({
    COMPONENT_V_MODEL: false,
    INSTANCE_CHILDREN: false,
    INSTANCE_LISTENERS: false,
    OPTIONS_BEFORE_DESTROY: false,
    OPTIONS_DESTROYED: false,
});

function createApp0(mainComponent: Component, el = '#app', rootProps?: Record<string, unknown> | null) {
    if(!document.querySelector(el)) {
        // may be deleted by skin
        return undefined;
    }
    const vueQueryPluginOptions: VueQueryPluginOptions = {
        queryClientConfig: {
            defaultOptions: {
                queries: {
                    refetchOnWindowFocus: false,
                },
            },
        },
    };

    const pinia = createPinia();

    const app = createApp(mainComponent, rootProps);
    app.use(pinia);
    app.use(VueQueryPlugin, vueQueryPluginOptions);
    app.mount(el);
    return app;
}

export { createApp0 as createApp };
